import React from 'react';
import Indicator from "components/modal/dataModal/data/modaljustify/address/component/indicator";
import Firstform from "components/modal/dataModal/data/modaljustify/address/component/body/firstform";
import Secondform from "components/modal/dataModal/data/modaljustify/address/component/body/secondform";
import Threeform from "components/modal/dataModal/data/modaljustify/address/component/body/threeform";
import Fourform
    from "components/modal/dataModal/data/modaljustify/address/component/body/fourform";
import Fiveform
    from "components/modal/dataModal/data/modaljustify/address/component/body/fiveform";
import CheckFilesIdentity from "../../identity/components/body/checkFilesIdentity";
 
const Multiform = ({formIndex,setFormIndex,setCheck,setProof,proof,attestation,setAttestation,check}) => {

    const elements = [
        <Firstform single={setProof} />,
        <CheckFilesIdentity key={CheckFilesIdentity} files={[proof]} />,
    ]

    const elements2 = [
        <Firstform single={setProof}/>,
        <CheckFilesIdentity key={CheckFilesIdentity} files={[proof]} />,
        <Secondform attest={setAttestation}/>,
        <CheckFilesIdentity key={CheckFilesIdentity} files={[attestation]} />,
        <Threeform setFormIndex={setFormIndex} setCheck={setCheck} />,
        <Fourform single={setProof} />,
        <CheckFilesIdentity key={CheckFilesIdentity} files={[proof]} />,
        <Fiveform attest={setAttestation}/>,
        <CheckFilesIdentity key={CheckFilesIdentity} files={[attestation]} />,
    ]


    return (
        <>
            {
                !check && (
                    <Indicator formIndex={formIndex}/>
                )
            }
            {
                check ? (
                    <>
                        {elements.map((item, index) => {
                            if((index + 1) === formIndex){
                                return elements[index]
                            }
                        })}
                    </>
                ) : (
                    <>
                        {elements2.map((item, index) => {
                            if((index + 1) === formIndex){
                                return elements2[index]
                            }
                        })}
                    </>
                )
            }
        </>
    );
};

export default Multiform;